export const PAGE_SIZE_REPORTS = 10;
